/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MaintenanceScheduleStateEnum = 'SCHEDULED' | 'CONFIRMED' | 'STARTED' | 'COMPLETED' | 'CANCELLED' | 'NONE';

export const MaintenanceScheduleStateEnum = {

    SCHEDULED: 'SCHEDULED' as MaintenanceScheduleStateEnum,

    CONFIRMED: 'CONFIRMED' as MaintenanceScheduleStateEnum,

    STARTED: 'STARTED' as MaintenanceScheduleStateEnum,

    COMPLETED: 'COMPLETED' as MaintenanceScheduleStateEnum,

    CANCELLED: 'CANCELLED' as MaintenanceScheduleStateEnum,

    NONE: 'NONE' as MaintenanceScheduleStateEnum
};

